
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setNewCategoryModalState } from '../../../redux/slices/components/ManagerJobs/managerJobsModalsSlice';
import { useAppDispatch } from '../../../redux/store/store';
import useCheckAccess from '../../hooks/useCheckAccess/useCheckAccess';
import "./HeaderManageJobs.css";

const HeaderManageJobs = () => {

    const { t } = useTranslation();
    const dispatch = useAppDispatch()

    const navigate = useNavigate()

    const accessEdit = useCheckAccess({ id_Category: "Manage_Jobs", id_Policy: "Category", id_Action: "Edit" })

    const handleAddCategory = () => {
        dispatch( setNewCategoryModalState() )
    }

    const goSimulator = () => {
        navigate(`/simulator`)
    }

    return (
        <div className="flex flex-jc-sb flex-ai-center">
            
            <p className="title-screen">
                {t("General:label_063")}
            </p>

            <div className="flex flex-ai-center flex-1">
                {
                    accessEdit &&
                    <button 
                        className="btn-beside-title-screen"
                        onClick={handleAddCategory}
                    >
                        <FontAwesomeIcon icon={faPlus} className="fs-14" />
                        <p className="text-btn-title-screen">{t("General:label_064")}</p>
                    </button> 
                }
                <button 
                    className="btn-beside-title-screen"
                    onClick={goSimulator}
                >
                    <p className="text-btn-title-screen">{"Simulator"}</p>
                </button> 
                
            </div>
        </div>
    )
}

export default React.memo( HeaderManageJobs )